// @flow
import React, { Component, type ComponentType } from "react";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import SpinnerIcon from "@material-ui/icons/Camera";
import PlayIcon from "@material-ui/icons/PlayCircleFilledWhite";
import ReactSwipeEvents from "react-swipe-events";
import dateFormat from "../../utils/localdateformat";

import { decode } from "../../utils/string";
import { getOriginal } from "../../utils/image";

import {
    Photo,
    Detail,
    DetailTop,
    Title,
    Date,
    Description,
    BackButton,
    NextButton,
    PlayButton,
    Overlay,
    Spinner,
    Wrapper
} from "./styled";

type Props = {|
    photo: ComponentType<any>,
    onNext: Function,
    onBack: Function
|};

class PhotoCard extends Component<Props> {
    state = {};

    componentDidMount() {
        // Add Event Listener on compenent mount
        window.addEventListener("keyup", this.keyHandling);
    }

    componentWillUnmount() {
        // Remove event listener on compenent unmount
        window.removeEventListener("keyup", this.keyHandling);
    }
    keyHandling = e => {
        const { onNext, onBack } = this.props;
        if (e.keyCode === 39) {
            onNext();
        } else if (e.keyCode === 37) {
            onBack();
        }
    };
    render() {
        const { photo, onNext, onBack } = this.props;
        const isVideo = photo.url.indexOf("/movies/") > 0;
        const movieUrl = photo.url.replace(".jpg", ".mp4");
        console.log({ url: photo.url, isVideo, movieUrl });

        return (
            <Wrapper>
                <Spinner>
                    <SpinnerIcon />
                </Spinner>
                <ReactSwipeEvents onSwipedLeft={() => onNext()} onSwipedRight={() => onBack()}>
                    <Photo
                        onKeyPress={this.handleKeyPress}
                        style={{
                            backgroundImage: `url(${getOriginal(photo.url)})`
                        }}
                    >
                        <Overlay>
                            <DetailTop>
                                <Date>{dateFormat(photo.date, "mmm dS yyyy")}</Date>
                            </DetailTop>

                            <BackButton onClick={() => onBack()}>
                                <NavigateBeforeIcon style={{ fontSize: 50 }} />
                            </BackButton>
                            <NextButton onClick={() => onNext()}>
                                <NavigateNextIcon style={{ fontSize: 50 }} />
                            </NextButton>
                            <Detail>
                                <Title>{decode(photo.title)}</Title>
                                <Description>
                                    {photo.description && <div>{decode(photo.description)}</div>}
                                </Description>
                            </Detail>
                        </Overlay>
                        {isVideo && (
                            <PlayButton>
                                <PlayIcon
                                    onClick={() => {
                                        window.open(movieUrl, "_blank");
                                    }}
                                    style={{ fontSize: 75 }}
                                />
                            </PlayButton>
                        )}
                    </Photo>
                </ReactSwipeEvents>
            </Wrapper>
        );
    }
}

export default PhotoCard;



// WEBPACK FOOTER //
// ./src/photo-dialog/photo-card/view.js